import { Loader } from '@/components/ui/loader';
import { cn } from '@/lib/utils';
import Image, { StaticImageData } from 'next/image';
import { useState } from 'react';

interface ImageWithLoaderProps {
  src: string | StaticImageData;
  alt: string;
  width: number;
  height: number;
  className?: string;
  imageclassname?: string;
  fill?: boolean;
  isFetchingImage?: boolean;
}

export default function ImageWithLoader({
  src,
  alt,
  width,
  height,
  className,
  imageclassname,
  fill = false,
  isFetchingImage = false,
  ...props
}: ImageWithLoaderProps & React.ComponentProps<typeof Image>) {
  const [isLoading, setIsLoading] = useState(true);

  function handleImageLoad() {
    setIsLoading(false);
  }

  return (
    <div className={cn('relative', className)}>
      {(isLoading || isFetchingImage) && (
        <div className="absolute inset-0 bg-black/50 flex items-center justify-center rounded-2xl">
          <Loader />
        </div>
      )}
      <Image
        src={src}
        alt={alt}
        width={!fill ? width : undefined}
        height={!fill ? height : undefined}
        className={cn(
          imageclassname,
          `transition-opacity duration-300 ${isLoading ? 'opacity-0' : 'opacity-100'}`,
        )}
        onLoad={handleImageLoad}
        fill={fill}
        unoptimized
        {...props}
      />
    </div>
  );
}
